import { Outlet } from "react-router-dom";
import EmbedProvider from "./EmbedProvider";

export default function EmbedViewerLayout() {
  return (
    <EmbedProvider isStandAlone>
      <Outlet />
    </EmbedProvider>
  );
}
